// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2CEqs","messages":"Chat_messages__21qCy","dateDivider":"Chat_dateDivider__3C5oQ"};